import { createSelector } from 'reselect';

const getScenePreviews = (state) => state.sceneConfiguration.previews;

const getPreviewScenes = createSelector([getScenePreviews], (previews) => previews);

export default getPreviewScenes;
